import actionTypes from '../../actionTypes';

const states = {
    openWidget: false,
    defaultPrice: {},
    shippingList: [],
    shippingCounts: 0,
    saveProcessing: false,
    shippingFetching: false,
    title: 'Shipping Rates',
    updateShipping: {},
    deletedRanges: [],
    free_shipping_rule: {},
    free_products: {
        initial_ids: []
    }
}

const ShippingReducer = (state = states, action) => {
    const { type, payload } = action
    switch (type) {
        case actionTypes.setOpenWidget:
            return {
                ...state,
                openWidget: payload
            }
        case actionTypes.setDefaultPrice:
            return {
                ...state,
                defaultPrice: payload
            }
        case actionTypes.saveFreeProducts:
            return {
                ...state,
                free_products: payload
            }
        case actionTypes.setUpdateShipping:
            return {
                ...state,
                updateShipping: payload
            }
        case actionTypes.saveFreeShippingRule:
            return {
                ...state,
                free_shipping_rule: action.payload
            }
        case actionTypes.saveShippingList:
            return {
                ...state,
                shippingList: payload
            }
        case actionTypes.setShippingCounts:
            return {
                ...state,
                shippingCounts: payload
            }
        case actionTypes.setSaveProcessing:
            return {
                ...state,
                saveProcessing: payload
            }
        case actionTypes.setFetching:
            return {
                ...state,
                shippingFetching: payload
            }
        case actionTypes.updateTitle:
            return {
                ...state,
                title: payload
            }
        case actionTypes.setDeleted:
            return {
                ...state,
                deletedRanges: payload
            }
        default:
            return state
    }
}

export default ShippingReducer